var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tabAdvertisements'),_vm._v(" "),(_vm.banners.length)?_c('div',_vm._l((_vm.banners),function(banner){return _c('HomeBanners',{key:banner.id,attrs:{"banners":banner}})}),1):_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-1"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ec93b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/profileDashboard/vendor/advertisements/homePage.vue
// module id = null
// module chunks = 